export const homeObjOne = {
  id: "about",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Premium Wallet",
  headline: "Unlimited Transactions ",
  description:
    "Get access to our exclusive app that allows you to send unlimited crypto transactions",
  buttonLabel: "Get Started",
  imgStart: false,
  img: require("../../images/svg-4.svg").default,
  alt: "Car",
  dark: true,
  primary: true,
  darkText: false,
};

export const homeObjTwo = {
  id: "discover",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Unlimited Access",
  headline: "Login to your account at any time",
  description:
    "We have you covered no matter where you are located. All you need is an internet connection and a phone or computer. All data is secured and private",
  buttonLabel: "Learn More",
  imgStart: true,
  img: require("../../images/svg-2.svg").default,
  alt: "Piggybank",
  dark: false,
  primary: false,
  darkText: true,
};

export const homeObjThree = {
  id: "signup",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Join our Team",
  headline: "Creating an account is extremely easy",
  description:
    "Get everything set up and ready in under 10 minutes. All you need to do is to have Metamask extension installed with your account. You can sign up via Gmail, Facebook or regular email sign-up",
  buttonLabel: "Start Now",
  imgStart: false,
  img: require("../../images/svg-3.svg").default,
  alt: "Papers",
  dark: false,
  primary: false,
  darkText: true,
};

export const homeObjFour = {
  id: "signup",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Join our Team",
  headline: "Creating an account is extremely easy",
  description:
    "Get everything set up and ready in under 10 minutes. All you need to do is to have Metamask extension installed with your account. You can sign up via Gmail, Facebook or regular email sign-up",
  buttonLabel: "Start Now",
  imgStart: false,
  img: require("../../images/svg-3.svg").default,
  alt: "Papers",
  dark: false,
  primary: false,
  darkText: true,
};

export const homeObjFive = {
  id: "discover",
  lightBg: true,
  lightText: false,
  lightTextDesc: true,
  topLine: "Premium Wallet",
  headline: "Unlimited Transactions ",
  description:
    "Get access to our exclusive app that allows you to send unlimited crypto transactions",
  buttonLabel: "Get Started",
  imgStart: false,
  img: require("../../images/svg-5.svg").default,
  alt: "Car",
  dark: false,
  primary: false,
  darkText: false,
};
